import { rem, type MantineTheme, type TooltipProps } from '@mantine/core';
import type { CSSProperties } from 'react';

export const LABEL_TOOLTIP_PROPS = {
  maw: 400,
  multiline: true,
  offset: 6,
  position: 'top',
  styles: {
    tooltip: {
      background: '#FFFFFF',
      border: '1px solid #FAFAFA',
      borderRadius: rem(6),
      boxShadow:
        '0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 8px 30px 0px rgba(0, 0, 0, 0.1)',
      color: '#171717',
      fontSize: rem(13),
      fontWeight: 500,
      lineHeight: 1.4,
      padding: rem(8),
    },
  },
  withArrow: false,
  withinPortal: true,
} satisfies Partial<TooltipProps>;

export const getTextHoverIndicatorSx =
  (cursor: CSSProperties['cursor'] = 'help') =>
  (theme: MantineTheme) => ({
    cursor,
    textDecorationColor: theme.colors.neutral[4],
    textDecorationLine: 'underline',
    textDecorationStyle: 'dashed',
    textDecorationThickness: rem(1),
    textUnderlineOffset: rem(3),
    ':hover': {
      textDecorationColor: theme.colors.neutral[5],
    },
  });
